<template lang="pug">
    component(
        :is="to ? 'router-link' : 'a'",
        class="_btn",
        :class="_class",
        :style="{ width, height }",
        :href="href",
        :to="to",
        :id="id",
        :inert="inert",
        :tabindex="inert ? -1 : tabindex",
        v-on="__on")
        slot
</template>

<script>
    import button from './ib-button.vue'

    /**
     * This is a derivative of [ib-button](#/components/button/ib-button) that is rendered using an `<a>` tag rather
     * than a `<button>` tag. It accepts `<a>` attributes such as `href`, `target`, and `rel`, and additionally
     * supports the `to` property of `router-link`.
     *
     * Use this anytime you need a button that directs the user to another page or route. This way, features such as
     * "open in new window" will work with the button.
     */
    export default {
        name: 'ib-button-link',
        mixins: [button],

        props: {
            /**
             * A hyperlink URL.
             */
            href: String,
            /**
             * A vue-router route; button will behave like `router-link`. This is an alternative
             * to `href`.
             */
            to: [String,Object]
        },

        mounted() {
            this.$el.addEventListener('dragstart', event => event.preventDefault());
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    a._btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        -webkit-user-drag: none;
        user-drag: none;
        color: @fg-button;
        background-color: @bg-button;
    }
</style>

<ib-example id="target" name="New Tab">
    <template lang="pug">
        div
            ib-button-link(href="https://www.interactivebrokers.com", target="_blank") Go to IBKR Homepage
    </template>
</ib-example>

<ib-example id="route" name="Route">
    <template lang="pug">
        div
            ib-button-link(to="/") Introduction
            ib-button-link(to="/guidelines") Guidelines
            ib-button-link(to="/modernization") Modernization
    </template>
</ib-example>
